import { render, staticRenderFns } from "./SingleArchive.vue?vue&type=template&id=ced9790a&scoped=true"
import script from "./SingleArchive.vue?vue&type=script&lang=js"
export * from "./SingleArchive.vue?vue&type=script&lang=js"
import style0 from "./SingleArchive.vue?vue&type=style&index=0&id=ced9790a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced9790a",
  null
  
)

export default component.exports